import { render, staticRenderFns } from "./dynamicFormSearch.vue?vue&type=template&id=5020da7c&scoped=true&"
import script from "./dynamicFormSearch.vue?vue&type=script&lang=js&"
export * from "./dynamicFormSearch.vue?vue&type=script&lang=js&"
import style0 from "./dynamicFormSearch.vue?vue&type=style&index=0&id=5020da7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020da7c",
  null
  
)

export default component.exports